import React from 'react';
import { Star, PartyPopper } from 'lucide-react';

const OpeningAnnouncementSection = () => {
  return (
    <section className="relative py-12 sm:py-16" style={{ backgroundColor: '#EE2535', borderTop: '4px solid #1A1918', borderBottom: '4px solid #1A1918' }} data-testid="opening-announcement">
      <div className="absolute inset-0 opacity-[0.06]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Cpath d='M100 180 L100 60 Q100 40 85 40 L85 25 Q85 10 100 10 L100 5 Q115 5 115 10 L115 25 Q130 25 130 40 L130 60 Q115 60 115 80 L115 180' fill='white'/%3E%3C/svg%3E")`,
        backgroundSize: '200px 200px'
      }} />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <Star size={14} fill="#F7B638" stroke="none" />
          <Star size={10} fill="#F7B638" stroke="none" />
          <PartyPopper style={{ width: '36px', height: '36px', color: '#F7B638' }} />
          <Star size={10} fill="#F7B638" stroke="none" />
          <Star size={14} fill="#F7B638" stroke="none" />
        </div>

        <h2
          className="font-display text-4xl sm:text-5xl lg:text-7xl mb-4 text-white"
          style={{ textShadow: '4px 4px 0 rgba(0,0,0,0.3)' }}
          data-testid="opening-date"
        >
          WE ARE NOW OPEN!
        </h2>

        <div className="zigzag-divider-gold max-w-xs mx-auto mb-5" />

        <p className="font-mono text-white/90 text-sm sm:text-base max-w-xl mx-auto mb-6">
          The fiesta has begun! Come experience Hyderabad's finest authentic Mexican cuisine at Casa Loco India.
        </p>

        <div className="inline-block px-6 py-3" style={{ backgroundColor: '#F7B638', color: '#1A1918', border: '3px solid #1A1918', boxShadow: '4px 4px 0 #1A1918' }}>
          <span className="font-display text-lg tracking-wider">2ND FLOOR, RADISSON HITEC CITY, GACHIBOWLI</span>
        </div>
      </div>
    </section>
  );
};

export default OpeningAnnouncementSection;